/* eslint-disable no-undef */

/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
(function () {
    'use strict';

    const serverHostname = "www.hospodskykviz.sk";
    if(serverHostname.indexOf('test.') >= 0 || serverHostname.indexOf('localhost') >= 0) {
      const footer = document.querySelector('.page-footer');
      const debugInfoSpan = document.createElement('div');
      debugInfoSpan.textContent = 'Napojeno na www.hospodskykviz.sk';
      debugInfoSpan.style="text-align: center; color: white;background-color: orange; padding: 10px; font-size: 16px;";
      footer.before(debugInfoSpan);
    }

    // Check to make sure service workers are supported in the current browser,
    // and that the current page is accessed from a secure origin. Using a
    // service worker from an insecure origin will trigger JS console errors. See
    // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
    var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    // IE 11 Array from method polyfill
    // Production steps of ECMA-262, Edition 6, 22.1.2.1
    if (!Array.from) {
        Array.from = (function () {
            var toStr = Object.prototype.toString;
            var isCallable = function (fn) {
                return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
            };
            var toInteger = function (value) {
                var number = Number(value);
                if (isNaN(number)) { return 0; }
                if (number === 0 || !isFinite(number)) { return number; }
                return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
            };
            var maxSafeInteger = Math.pow(2, 53) - 1;
            var toLength = function (value) {
                var len = toInteger(value);
                return Math.min(Math.max(len, 0), maxSafeInteger);
            };

            // The length property of the from method is 1.
            return function from(arrayLike/*, mapFn, thisArg */) {
                // 1. Let C be the this value.
                var C = this;

                // 2. Let items be ToObject(arrayLike).
                var items = Object(arrayLike);

                // 3. ReturnIfAbrupt(items).
                if (arrayLike == null) {
                    throw new TypeError('Array.from requires an array-like object - not null or undefined');
                }

                // 4. If mapfn is undefined, then let mapping be false.
                var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                var T;
                if (typeof mapFn !== 'undefined') {
                    // 5. else
                    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                    if (!isCallable(mapFn)) {
                        throw new TypeError('Array.from: when provided, the second argument must be a function');
                    }

                    // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    if (arguments.length > 2) {
                        T = arguments[2];
                    }
                }

                // 10. Let lenValue be Get(items, "length").
                // 11. Let len be ToLength(lenValue).
                var len = toLength(items.length);

                // 13. If IsConstructor(C) is true, then
                // 13. a. Let A be the result of calling the [[Construct]] internal method
                // of C with an argument list containing the single item len.
                // 14. a. Else, Let A be ArrayCreate(len).
                var A = isCallable(C) ? Object(new C(len)) : new Array(len);

                // 16. Let k be 0.
                var k = 0;
                // 17. Repeat, while k < len… (also steps a - h)
                var kValue;
                while (k < len) {
                    kValue = items[k];
                    if (mapFn) {
                        A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                    } else {
                        A[k] = kValue;
                    }
                    k += 1;
                }
                // 18. Let putStatus be Put(A, "length", len, true).
                A.length = len;
                // 20. Return A.
                return A;
            };
        }());
    }

    if ('serviceWorker' in navigator &&
        (window.location.protocol === 'https:' || isLocalhost)) {
        navigator.serviceWorker.register('service-worker.js')
            .then(function (registration) {
                // updatefound is fired if service-worker.js changes.
                registration.onupdatefound = function () {
                    // updatefound is also fired the very first time the SW is installed,
                    // and there's no need to prompt for a reload at that point.
                    // So check here to see if the page is already controlled,
                    // i.e. whether there's an existing service worker.
                    if (navigator.serviceWorker.controller) {
                        // The updatefound event implies that registration.installing is set:
                        // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
                        var installingWorker = registration.installing;

                        installingWorker.onstatechange = function () {
                            switch (installingWorker.state) {
                                case 'installed':
                                    // At this point, the old content will have been purged and the
                                    // fresh content will have been added to the cache.
                                    // It's the perfect time to display a "New content is
                                    // available; please refresh." message in the page's interface.
                                    break;

                                case 'redundant':
                                    throw new Error('The installing ' +
                                        'service worker became redundant.');

                                default:
                                // Ignore
                            }
                        };
                    }
                };
            }).catch(function (e) {
            console.error('Error during service worker registration:', e);
        });
    }
})();

const dataSaveColor = '#d9fbd9';

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

class HospodskyKviz {
    init() {
        this.useShots = ('true' == 'true');

        HospodskyKviz._initMaterializePlugins();
        this._initOnlineIndicator();
        this._loadJsonSource();
        this._triggerSynchronizeResults();
        this._triggerNote();
        this._triggerCreateTeamSubmit();
        this._triggerQuestionForm();
        this._triggerSendResultForm();
        this.triggerShotsForm();
    }

    render() {
        if (localStorage.getItem('json-source') !== null) {
            this._renderRoundList();

            this._renderTeamList2();
            this._loadDefaultNoteFormValues();
            this._triggerCreateTeam();

            $('select').material_select();

            $('autocomplete').autocomplete({
                data: {
                    "Apple": null,
                    "Microsoft": null,
                    "Google": 'https://placehold.it/250x250'
                },
                limit: 20, // The max amount of results that can be shown at once. Default: Infinity.
                onAutocomplete: function(val) {
                    // Callback function when value is autcompleted.
                },
                minLength: 1, // The minimum length of the input for the autocomplete to start. Default: 1.
            });

            this._renderContinuousOrder();

            //odstranit schovane prvky
            this._removeInitHide();
            this._triggerDeleteQuiz();

            this.renderShotsForm();
        }
    }

    static _initMaterializePlugins() {
        $('.button-collapse').sideNav();
        $('.modal').modal();
    }

    _removeInitHide() {
        $('.init').removeClass('hide');
    }

    _addInitHide() {
        $('.init').removeClass('active');
        $('.init').addClass('hide');
    }

    _initOnlineIndicator() {
        window.addEventListener('load', () => {
            const indicatorState = HospodskyKviz.getOnlineIndicatorState();
            HospodskyKviz._updateOnlineIndicatorEl(indicatorState);
        }, true);

        window.addEventListener('online', () => HospodskyKviz._updateOnlineIndicatorEl('online'));
        window.addEventListener('offline', () => HospodskyKviz._updateOnlineIndicatorEl('offline'));
    }

    static getOnlineIndicatorState() {
        return (navigator.onLine) ? 'online' : 'offline';
    }

    static _updateOnlineIndicatorEl(state) {
        const statusElement = document.getElementById('online-status-indicator');

        // Reset třídy
        statusElement.removeAttribute('class');
        statusElement.classList.add('hide', 'btn-floating', 'btn-large');
        if (state === 'online') {
            Materialize.toast('Aplikace přešla do režimu ONLINE', 5000);

            statusElement.classList.add('green', 'pulse');
            statusElement.querySelector('i').innerText = 'language';
        } else {
            Materialize.toast('Aplikace přešla do režimu OFFLINE', 5000);

            statusElement.classList.add('disabled');
            statusElement.querySelector('i').innerText = 'portable_wifi_off';
        }
        statusElement.classList.remove('hide');
    }

    static _getSampleJsonData() {
        return {
            rounds: {
                1: {
                    questions: [
                        'a',
                        'b'
                    ]
                },
                2: {
                    questions: [
                        'a',
                        'b',
                        'c'
                    ]
                },
                3: {
                    questions: [
                        'a',
                        'b'
                    ]
                }
            },
            teams: [
                {
                    uuid: 'asddas',
                    name: 'AABBCC'
                },
                {
                    uuid: 'aasddsas',
                    name: 'XXBBCC'
                },
                {
                    uuid: 'AAA',
                    name: 'XXBasddsasadBCC'
                }
            ]
        };
    }

    _loadJsonSource() {
        if (localStorage.getItem('json-source') === null) {
            const pinModalEl = $('#modal-pin-verify');
            pinModalEl.modal('open');

            const formEl = document.getElementById('pin-form');
            formEl.addEventListener('submit', event => {
                event.preventDefault();

                const pin = formEl.querySelector('input[name="pin"]').value;
                $.ajax({
                    method: 'POST',
                    url: 'https://www.hospodskykviz.sk/api/loadquiz',
                    data: {pin: pin},
                    dataType: 'json'
                }).done(function (response) {
                    if (response.state === false) {
                        //alert(response.message);
                        this._showModalMessage('Chyba pri nahrávaní kvízu', response.message);
                    } else {
                        this._addJsonSourceToLocalStorage(response);

                        //set count of round to local storage
                        const roundCount =  Object.keys(response.rounds).length;
                        let rounds = {};

                        for(let i = 1; i <= roundCount; i++){
                            rounds[i] = [];
                        }

                        localStorage.setItem('filledSupplementQuestions', JSON.stringify(rounds));

                        pinModalEl.modal('close');
                        this._renderRoundList();
                        this._renderTeamList2();
                        this._triggerCreateTeam();
                        $('select').material_select();
                        this._removeInitHide();
                        this.renderShotsForm();
                    }
                }.bind(this));
            });
        }
    }

    _getTeamList() {
        let result = null;
        const jsonData = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (jsonData) {
            result = jsonData.teams;
        }
        return result;
    }

    /**
     * Every team eligible for this pub (HOK-392 allTeams). Falls back to
     * teams for a json-source cached before allTeams existed, when teams
     * still meant "all eligible teams". Always returns an array.
     * @return {Array<Object>} team entries {uuid, name, member_count, email, onLastQuiz}
     */
    _getAllTeamList() {
        const jsonData = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (!jsonData) {
            return [];
        }
        return jsonData.allTeams || jsonData.teams || [];
    }

    /**
     * Eligible teams that did not confirm attendance: allTeams minus the
     * uuids already present in json-source.teams (confirmed, promoted and
     * moderator-created teams alike).
     * @return {Array<Object>} team entries in allTeams order
     */
    _getOtherTeamList() {
        const listed = {};
        const teams = this._getTeamList() || [];
        for (let i = 0; i < teams.length; i++) {
            listed[teams[i].uuid] = true;
        }
        return this._getAllTeamList().filter(team => !listed[team.uuid]);
    }

    /**
     * Moves "other" teams that the moderator gave a member count to into
     * json-source.teams, so from then on they behave like confirmed teams.
     * @param {Object} teamMembers shape produced by _membersInputsToTeamMembers
     * @return {number} how many teams were promoted
     */
    _promoteOtherTeams(teamMembers) {
        const teamList = this._getTeamList();
        if (!teamList) {
            return 0;
        }

        const otherTeams = this._getOtherTeamList();
        const promotedUuids = this._getPromotedTeamUuids();
        let promoted = 0;
        for (let i = 0; i < otherTeams.length; i++) {
            const entry = teamMembers['team-uuid-' + otherTeams[i].uuid];
            if (entry && entry.value > 0) {
                teamList.push(otherTeams[i]);
                if (promotedUuids.indexOf(otherTeams[i].uuid) === -1) {
                    promotedUuids.push(otherTeams[i].uuid);
                }
                promoted++;
            }
        }

        if (promoted > 0) {
            teamList.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            this._saveTeamList(teamList);
            localStorage.setItem('promoted-teams', JSON.stringify(promotedUuids));
        }
        return promoted;
    }

    /**
     * Uuids of teams the moderator promoted from the "other" block; only
     * these can be removed from the team list again.
     * @return {Array<string>} uuids, empty when nothing was promoted
     */
    _getPromotedTeamUuids() {
        return JSON.parse(localStorage.getItem('promoted-teams')) || [];
    }

    /**
     * Reverses _promoteOtherTeams for one team: drops it from
     * json-source.teams, promoted-teams and teamMembers and deletes its
     * results. Teams that were not promoted (confirmed, guest, created) are
     * left untouched.
     * @param {string} uuid team uuid
     * @return {boolean} true when the team was demoted
     */
    _demoteTeam(uuid) {
        const promotedUuids = this._getPromotedTeamUuids();
        if (promotedUuids.indexOf(uuid) === -1) {
            return false;
        }

        this._saveTeamList((this._getTeamList() || []).filter(team => team.uuid !== uuid));
        localStorage.setItem('promoted-teams', JSON.stringify(promotedUuids.filter(item => item !== uuid)));

        const teamMembers = JSON.parse(localStorage.getItem('teamMembers'));
        if (teamMembers) {
            delete teamMembers['team-uuid-' + uuid];
            localStorage.setItem('teamMembers', JSON.stringify(teamMembers));
        }

        this._removeTeamResults(uuid);
        return true;
    }

    /**
     * Deletes everything scored for one team: its round-* keys, its entries
     * in filledSupplementQuestions and its bonus answer / bonus-winner mark.
     * @param {string} uuid team uuid
     * @return {undefined}
     */
    _removeTeamResults(uuid) {
        const suffix = '--teamUuid-' + uuid;
        const roundKeys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.indexOf('round-') === 0 && key.length - key.lastIndexOf(suffix) === suffix.length) {
                roundKeys.push(key);
            }
        }
        roundKeys.forEach(key => localStorage.removeItem(key));

        const filledSupplementQuestions = JSON.parse(localStorage.getItem('filledSupplementQuestions'));
        if (filledSupplementQuestions) {
            for (let round in filledSupplementQuestions) {
                if (filledSupplementQuestions.hasOwnProperty(round)) {
                    filledSupplementQuestions[round] = filledSupplementQuestions[round].filter(item => item !== uuid);
                }
            }
            localStorage.setItem('filledSupplementQuestions', JSON.stringify(filledSupplementQuestions));
        }

        const bonus = JSON.parse(localStorage.getItem('bonus'));
        if (bonus && bonus.hasOwnProperty(uuid)) {
            delete bonus[uuid];
            localStorage.setItem('bonus', JSON.stringify(bonus));
        }
        if (localStorage.getItem('bonusQuestionTeam') === uuid) {
            localStorage.removeItem('bonusQuestionTeam');
        }
    }

    _saveTeamList(teamList) {
        const jsonData = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (jsonData) {
            jsonData.teams = teamList;
            localStorage.setItem('json-source', JSON.stringify(jsonData));
        }
    }

    _saveNewTeam(newTeam) {
        let teamList = [];
        if (localStorage.getItem('new-teams') !== null) {
            teamList = JSON.parse(localStorage.getItem('new-teams'));
        }
        teamList.push(newTeam);
        localStorage.setItem('new-teams', JSON.stringify(teamList));
    }

    _getPubList() {
        let result = null;
        const jsonData = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (jsonData) {
            result = jsonData.pubs;
        }
        return result;
    }

    _getQuestionList() {
        let result = null;
        const jsonData = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (jsonData) {
            result = jsonData.rounds;
        }
        return result;
    }

    _getBonusQuestion() {
        let result = null;
        const jsonData = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (jsonData) {
            result = jsonData.bonus;
        }
        return result;
    }

    _renderFormTeamFields() {
        const teams = this._getTeamList();
        let result = '';
        for (let key in teams) {
            if (teams.hasOwnProperty(key)) {
                let teamName = teams[key].name;
                let teamUuid = teams[key].uuid;
                result += `
        <div class="input-field col s12 m6 l3">
          <input placeholder="body" id="team-uuid-` + teamUuid + `" type="number" step="0.5" min="0" max="100" class="validate">
          <label for="team-uuid-` + teamUuid + `">` + teamName + `</label>
        </div>`;
            }
        }
        return result;
    }

    /**
     * Risk question: a wrong answer is scored -1.
     * A missing isRisky key (quiz loaded before the update) means false;
     * iknow questions are never risky, whatever the payload says.
     */
    static _isQuestionRisky(question) {
        return question['isRisky'] === true && question['type'] !== 'iknow';
    }

    /**
     * Round results are stored keyed by input id; strips the id prefix
     * (bod-uuid-, pul-bod-uuid-, minus-bod-uuid-) to get the question uuid.
     */
    static _questionUuidFromInputId(inputId) {
        return inputId.replace(/^(pul-|minus-)?bod-uuid-/, '');
    }

    _renderQuestionList(round) {
        let questions = [];
        if (round) {
            questions = this._getQuestionList()[round].questions;
        }
        // the minus point column is rendered only when the round has a risk question
        let roundHasRisky = false;
        for (let key in questions) {
            if (questions.hasOwnProperty(key) && HospodskyKviz._isQuestionRisky(questions[key])) {
                roundHasRisky = true;
            }
        }

        let result =
            '<table>' +
            '<tr>' +
            '<th>otázka</th>' +
            '<th>bod</th>' +
            '<th>pol bod</th>' +
            (roundHasRisky ? '<th>mínus bod</th>' : '') +
            '<th>odpoveď</th>' +
            '</tr>';

        for (let key in questions) {
            if (questions.hasOwnProperty(key)) {
                let i = Number(key) + 1;
                let questionUuid = questions[key]['uuid'];
                let answer = questions[key]['answer'];
                let isSupplement = questions[key]['is_supplement'];
                let hasHalfPoint = questions[key]['isHalfPoint'];
                let headerText = i + '.';

                if (isSupplement) {
                    headerText = 'Doplnková';
                }

                let halfPointStyle = '';
                if(!hasHalfPoint) {
                    halfPointStyle = 'display: none';
                }

                result += `<tr>
                <!--<div class="form-field col s12 m12 l3">-->
                <td>
                <label >` + headerText + `</label>
                </td>
                <td>
                <input class="question-radio" value="1" type="radio" name="group-` + questionUuid + `" id="bod-uuid-` + questionUuid + `" data-is-supplement="` + isSupplement + `">
                <label class="radio-point-background-color" for="bod-uuid-` + questionUuid + `"></label>
                </td>
                <td>`;
                if (!isSupplement) {
                    result += `
                    <div style="` + halfPointStyle + `">
                        <input class="question-radio" value="0.5" type="radio" name="group-` + questionUuid + `" id="pul-bod-uuid-` + questionUuid + `">
                        <label class="radio-half-point-background-color" for="pul-bod-uuid-` + questionUuid + `"></label>
                    </div>
                    `;
                }

                if (roundHasRisky) {
                    result += `
                </td>
                <td>`;
                    if (HospodskyKviz._isQuestionRisky(questions[key])) {
                        result += `
                    <input class="question-radio" value="-1" type="radio" name="group-` + questionUuid + `" id="minus-bod-uuid-` + questionUuid + `" data-is-supplement="` + isSupplement + `">
                    <label class="radio-minus-point-background-color" for="minus-bod-uuid-` + questionUuid + `"></label>
                    `;
                    }
                }

                result += `
                </td>
                <td>
                    <label >` + answer + `</label>
                </td>
                <!--</div>-->
                </tr>`;
            }
        }

        result += '</table>';
        return result;
    }

    _renderRoundList() {
        const roundsAndQuestions = this._getQuestionList();
        let result = '';
        for (let key in roundsAndQuestions) {

            if (roundsAndQuestions.hasOwnProperty(key)) {
                let i = Number(key);

                if(this._isTopicIknow(roundsAndQuestions[i]['questions'])){
                    result += `
                <li data-round="` + i + `">
                  <div class="collapsible-header"><i class="material-icons">filter_tilt_shift</i><b>` + i + `</b>. kolo - iKnow</div>
                  <div class="collapsible-body"><div class="collection">` + this._renderIknowQuestionList(i) + `</div></div>
                </li>`;
                }
                else {
                    result += `
                <li data-round="` + i + `">
                  <div class="collapsible-header"><i class="material-icons">filter_tilt_shift</i><b>` + i + `</b>. kolo</div>
                  <div class="collapsible-body"><div class="collection">` + this._renderTeamList(i) + `</div></div>
                </li>`;
                }
            }
        }

        const bonusQuestion = this._getBonusQuestion();
        if (bonusQuestion) {
            let questionUuid = bonusQuestion['uuid'];
            let answer = bonusQuestion['answer'];
            result += `<ul id="bonus-list-collapsible" class="collapsible popout" data-collapsible="accordion">
                <li>
                    <div  class="collapsible-header"><i class="material-icons">card_giftcard</i><b>Bonusová otázka</b></div>
                    <div class="collapsible-body"><div class="collection">
                       ` + this._renderFormForBonusQuestion(answer) + `
                    </div>
                    </div>
                </li></ul>`;
        }

        //titulek kvizu = jmeno hospody a datum
        document.getElementById('quiz-title').innerHTML = this._getTitle();

        document.getElementById('round-list').innerHTML = result;

        this._triggerModal();
        this._triggerBonusForm();
        this._triggerTeamListModal();

        $('.collapsible').collapsible();
    }

    _renderIknowQuestionList(roundOrder){
        let questions = JSON.parse(localStorage.getItem('json-source'))['rounds'][roundOrder]['questions'];

        let result = '';
        let questionPosition = '';
        for(let questionOrder in questions){

            if(questions.hasOwnProperty(questionOrder)){
                let questionUuid = questions[questionOrder]['uuid'];
                questionOrder++;

                if(questionOrder ===  questions.length) {
                    questionPosition = 'Doplnková otázka';
                }
                else {
                    questionPosition = questionOrder + '. otázka';
                }

                result += `
                     <a style="background: ` + "#ffffff" + `" href="" class="collection-item  modal-list-team-trigger modal-list-team" data-answer-order="` + questionOrder + `"data-iknow-answer-uuid="` + questionUuid + `" data-round-id="` + roundOrder + `">
                     <span class="badge new blue" style="margin-top: 0" data-badge-caption="zadať výsledky"></span>` + questionPosition + `</a>`;
            }
        }
        return result;
    }

    _triggerTeamListModal() {
        // const questionLinks = document.querySelectorAll('.question-modal');

        const teamListLinks = document.querySelectorAll('.modal-list-team');

        Array.from(teamListLinks).forEach(link => {
            link.addEventListener('click', () => {
                event.preventDefault();
                let answerUuid = link.getAttribute('data-iknow-answer-uuid');
                let answerOrder = link.getAttribute('data-answer-order');
                let roundOrder = link.getAttribute('data-round-id');
                let buttonEl = document.getElementById('modal-list-team').querySelector('button');

                this._renderTeamListModal(answerUuid, answerOrder, roundOrder);
                this.addIknowTeamListListener(buttonEl);
            });
        });
    }

    addIknowTeamListListener(buttonEl){
        buttonEl.addEventListener('click', event => {
            $('#modal-list-team').modal('close');
        });
    }

    _renderTeamListModal(answerUuid, answerOrder, roundOrder) {
        const modalEl = document.getElementById('modal-list-team');

        const teamListContent = modalEl.querySelector('.iknow-team-list');

        teamListContent.innerHTML = this.getIknowTeamList(answerUuid, answerOrder, roundOrder);

        this._triggerIknowAnswer();

        Materialize.updateTextFields();
        $('#modal-list-team').modal('open');
        $('#modal-list-team .modal-content').scrollTop(0);
    }


    getIknowTeamList(answerUuid, answerOrder, roundOrder) {
        const key = 'teamMembers';
        const teams = JSON.parse(localStorage.getItem(key));

        let result = '';
        let bgColor;
        for (let teamUuid in teams) {
            if (teams[teamUuid].value > 0) {
                if (teams.hasOwnProperty(teamUuid)) {

                    if(this.hasCheckedTeamQuestionResult(teamUuid, roundOrder, answerUuid)){
                        bgColor = dataSaveColor;
                    }
                    else {
                        bgColor = "#ffffff";
                    }

                    result += "<a href=\"\" class=\"collection-item  modal-iknow-answer-trigger modal-iknow-answer\"" +
                        " data-answer-uuid=\"" + answerUuid +
                        "\"data-answer-order=\"" + answerOrder +
                        "\"data-team-uuid=\"" + teamUuid +
                        "\"data-round-order=" + roundOrder +
                        "><span style='background: " + bgColor + "'>" + teams[teamUuid]['name'] + "</span></a><br>";
                }
            }
        }

        return result;
    }

    hasCheckedTeamQuestionResult(teamUuid, round, questionUuid) {

        let questions = this.sortQuestionsByUuid(round);
        let resultPrefix;

        let key = 'round-' + round + "--teamUuid" + teamUuid.replace('team-uuid', '');

        if (questions[questionUuid].is_supplement) {
            resultPrefix = "pul-bod-uuid-";
        } else {
            resultPrefix = "bod-uuid-";
        }

        let teamResult = JSON.parse(localStorage.getItem(key));

        if (teamResult) {
            if (teamResult[resultPrefix + questionUuid]) {
                if ((teamResult[resultPrefix + questionUuid].value > 0) || ((teamResult[resultPrefix + questionUuid].value === "0") && (teamResult[resultPrefix + questionUuid].checked))) {
                    return true
                }
            }
        }

        return false;
    }

    _triggerIknowAnswer() {
        const answerLinks = document.querySelectorAll('.modal-iknow-answer');

        Array.from(answerLinks).forEach(link => {
            link.addEventListener('click', () => {
                event.preventDefault();

                let answerUuid = link.getAttribute('data-answer-uuid');
                let answerOrder = link.getAttribute('data-answer-order');
                let roundOrder = link.getAttribute('data-round-order');
                let teamUuid = link.getAttribute('data-team-uuid');

                this._renderIknowAnswer(answerUuid, answerOrder, roundOrder, teamUuid);
                this._loadDefaultIknowQuestionFormValues(roundOrder, teamUuid);
            });
        });
    }

    sortQuestionsByUuid(roundOrder) {
        let questions = JSON.parse(localStorage.getItem('json-source'))['rounds'][roundOrder]['questions'];

        let sortedQuestions = [];

        for (let questionOrder in questions) {
            sortedQuestions[questions[questionOrder].uuid] = questions[questionOrder];
        }

        return sortedQuestions;
    }

    _loadDefaultIknowQuestionFormValues(roundOrder, teamUuid) {

        let questions = this.sortQuestionsByUuid(roundOrder);

        let key = '';
        if (roundOrder) {
            key = 'round-' + roundOrder + "--teamUuid" + teamUuid.replace('team-uuid', '');
        } else {
            key = 'bonus--teamUuid-' + teamUuid;
        }

        const defaultValues = JSON.parse(localStorage.getItem(key));

        if (defaultValues) {
            for (let key in defaultValues) {
                if (defaultValues.hasOwnProperty(key)) {
                    let checked = defaultValues[key].checked;
                    let uuid = defaultValues[key].questionUuid;
                    let value = defaultValues[key].value;
                    let answerSelector;
                    let strippedUuid = uuid.replace('bod-uuid-','').replace('pul-', '');

                    if (questions[strippedUuid]) {
                        if (questions[strippedUuid].is_supplement) {

                            for (let i = 0; i < 2; i++) {

                                if(value === "0.5"){
                                    answerSelector = 'pul-bod-uuid-' + strippedUuid;
                                    checked = true;
                                }
                                else {
                                    answerSelector = i + '-bod-uuid-' + strippedUuid;
                                    checked = (value == i);
                                }

                                let answerEl = document.getElementById(answerSelector);

                                if (answerEl) {
                                    answerEl.checked = checked;
                                }
                            }

                        }
                        else {
                            for (let questionOrder = 3; questionOrder >= 0; questionOrder--) {

                                let answerSelector = questionOrder + '-bod-uuid-' + uuid + '---' + questionOrder;
                                let answerEl = document.getElementById(answerSelector);

                                if (answerEl) {
                                    answerEl.checked = (value == questionOrder);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    _renderIknowAnswer(answerUuid, answerOrder, roundOrder, teamUuid) {
        let modalEl = document.getElementById('modal-iknow-answer');
        let answerPointsEl = modalEl.querySelector('#iknow-answer-points');
        let formEl = modalEl.querySelector('#question-iknow-form');
        let answerEl = modalEl.querySelector('#iknow-answer');
        let title = modalEl.querySelector('h5');
        let questions = JSON.parse(localStorage.getItem('json-source'))['rounds'][roundOrder]['questions'];
        let team = JSON.parse(localStorage.getItem("teamMembers"))[teamUuid];
        let answer = null;
        let pointsEl = "";

        this.addIknowListener(formEl,roundOrder);

        for(let order in questions){
            if (questions[order]['uuid'] === answerUuid) {
                answer = questions[order];
            }

        }
        if(answer === null){
            answer = [];
            answer['answer'] = '<span style="color: red">Při načítání odpovědi došlo k chybě</span>';

        }
        //set values to hidden elements
        const roundEl = modalEl.querySelector('input[name="round"]');
        const teamUuidEl = modalEl.querySelector('input[name="teamUuid"]');
        const questionUuidEl = modalEl.querySelector('input[name="questionUuid"]');
        roundEl.value = roundOrder;
        teamUuidEl.value = teamUuid;

        questionUuidEl.value = answerUuid;

        if(answer.is_supplement){

            answerOrder = "Doplnková otázka";

				pointsEl+= "<input class=\"question-radio\" value=\"1\" type=\"radio\" name=\"group-" + answerUuid + "\" id=\"1-bod-uuid-" + answerUuid + "\" data-is-supplement=\"true\">";
				pointsEl += "<label class=\"radio-point-background-color\" for=\"1-bod-uuid-" + answerUuid + "\"> 1 bod</label>  ";

				if(answer.isHalfPoint){
                    pointsEl+= "<input class=\"question-radio\" value=\"0.5\" type=\"radio\" name=\"group-" + answerUuid + "\" id=\"pul-bod-uuid-" + answerUuid + "\" data-is-supplement=\"true\">";
                    pointsEl += "<label class=\"radio-point-background-color\" for=\"pul-bod-uuid-" + answerUuid + "\"> 0.5 bodu</label>  ";
                }

                pointsEl+= "<input class=\"question-radio\" value=\"0\" type=\"radio\" name=\"group-" + answerUuid + "\" id=\"0-bod-uuid-" + answerUuid + "\" data-is-supplement=\"true\">";
                pointsEl += "<label class=\"radio-point-background-color\" for=\"0-bod-uuid-" + answerUuid + "\"> 0 bodů</label>  ";
        }
        else {
            answerOrder += ". otázka";

			for(let i = 3; i >= 0; --i) {
				pointsEl+= "<input class=\"question-radio\" value=\"" + i + "\" type=\"radio\" name=\"group-\"" + answerUuid + "\" id=\"" + i + "-bod-uuid-" + answerUuid + "---"+ i + "\" data-is-supplement=\"false\">";
                if (i === 1) {
                    pointsEl += "<label class=\"radio-point-background-color\" for=\"" + i + "-bod-uuid-" + answerUuid + "---"+ i + "\">" + i + " bod</label>  ";
                } else if (i === 0) {
                    pointsEl += "<label class=\"radio-point-background-color\" for=\"" + i + "-bod-uuid-" + answerUuid + "---"+ i + "\">" + i + " bodů</label>  ";
                } else {
                    pointsEl += "<label class=\"radio-point-background-color\" for=\"" + i + "-bod-uuid-" + answerUuid + "---"+ i + "\">" + i + " body</label>  ";
                }
			}
        }

        let titleText = team['name'] + " " + roundOrder + ". Kolo - " + answerOrder;

        title.innerHTML = titleText;
        answerEl.innerHTML = answer['answer'];
        answerPointsEl.innerHTML = pointsEl;

        $('#modal-iknow-answer').modal('open');
        $('#modal-iknow-answer .modal-content').scrollTop(0);
    }

    pointIknowInputsToTeamPoints(pointsEl, roundOrder, teamUuid) {
        let questions = JSON.parse(localStorage.getItem('json-source'))['rounds'][roundOrder]['questions'];
        let resultKey = 'round-' + roundOrder + '--teamUuid-' + teamUuid;
        let roundResult = JSON.parse(localStorage.getItem(resultKey));
        let prefix = "bod-uuid-";
        let questionUuid;
        let actualQuestion = null;

        if (!roundResult) {

            roundResult = {};

            for (let questionOrder in questions) {

                if (questions[questionOrder].is_supplement) {
                    roundResult[ "pul-" + prefix + questions[questionOrder].uuid] = {
                        "questionUuid": "pul-" + questions[questionOrder].uuid,
                        "checked": false,
                        "value": null,
                    };
                } else {
                    roundResult[prefix + questions[questionOrder].uuid] = {
                        "questionUuid": questions[questionOrder].uuid,
                        "checked": false,
                        "value": null,
                    };
                }
            }
        }

        for (let pointElOrder in pointsEl) {

            if (typeof pointsEl[pointElOrder] === "object") {
                let questionValue = pointsEl[pointElOrder].value;

                questionUuid = pointsEl[pointElOrder].getAttribute("id").replace('bod-uuid-', '').replace('pul-', '');
                questionUuid = questionUuid.replace('---' + questionValue,'').replace(questionValue+'-','');

                if (pointsEl[pointElOrder].checked) {
                    for (let questionOrder in questions) {
                        if (questions[questionOrder].uuid === questionUuid) {

                            if(questions[questionOrder].is_supplement){
                                let filledSupplementQuestions = JSON.parse(localStorage.getItem('filledSupplementQuestions'));
                                filledSupplementQuestions[roundOrder].push(questionUuid);
                                localStorage.setItem('filledSupplementQuestions', JSON.stringify(filledSupplementQuestions));
                            }

                            actualQuestion = {
                                "questionUuid": (questions[questionOrder].is_supplement) ? "pul-" + questionUuid : questionUuid,
                                "checked": true,
                                "value": questionValue,
                            };
                        }
                    }
                }
            }
        }

        for (let resultRound in roundResult) {
            if (actualQuestion && roundResult[resultRound].questionUuid === actualQuestion.questionUuid) {

                roundResult[resultRound] = actualQuestion
            }
        }

        this._addTeamPointsToLocalStorage(roundResult, roundOrder, teamUuid);
    }

    addIknowListener(formEl, roundOrder){
        formEl.addEventListener('submit', event => {

            event.preventDefault();

            const pointsEl = formEl.querySelector('#iknow-answer-points').querySelectorAll('input[type="radio"]');
            const teamUuid = formEl.querySelector('input[name="teamUuid"]').value.replace('team-uuid-','');
            const answerUuid = formEl.querySelector('input[name="questionUuid"]').value;

            let formattedPoints = this.pointIknowInputsToTeamPoints(pointsEl,roundOrder,teamUuid);

            this._renderContinuousOrder();

            $('a[data-team-uuid="team-uuid-' + teamUuid + '"][data-answer-uuid="' + answerUuid + '"] span').css('background', dataSaveColor);

            $('#modal-iknow-answer').modal('close');
        });
    }

    //check if round is type of iKnow
    _isTopicIknow(questions) {

        for (let questionOrder in questions) {

            if (questions.hasOwnProperty(questionOrder)) {

                if (questions[questionOrder]['type'] === 'iknow') {
                    return true;
                }
            }
        }

        return false;
    }

    _renderTeamList(round) {
        const key = 'teamMembers';
        const teams = JSON.parse(localStorage.getItem(key));

        let result = '';
        for (let key in teams) {
            if (teams.hasOwnProperty(key)) {
                let teamName = teams[key].name;
                let members = teams[key].value;
                let teamUuid = teams[key].teamUuid;
                if (members > 0) {
                    //podbarvy zelene pokud jsou ulozeny vysledky v localstorage
                    let color = '#ffffff';
                    if (this._hasTeamSaveResult(teamUuid, round)) {
                        color = dataSaveColor;
                    }

                    result += `
                    <a style="background: ` + color + `" href="" class="collection-item modal-trigger question-modal" data-round="` + round + `" data-team-uuid="` + teamUuid + `" data-team-name="` + teamName + `">
                    <span class="badge new blue" style="margin-top: 0" data-badge-caption="zadať výsledky"></span>` + teamName + `</a>`;
                } else {
                    //smaz vysledky z local storage
                    const roundsAndQuestions = this._getQuestionList();
                    let result = '';
                    for (let key in roundsAndQuestions) {
                        if (roundsAndQuestions.hasOwnProperty(key)) {
                            let i = Number(key);
                            const teamResultKey = 'round-' + i + '--teamUuid-' + teamUuid;
                            if (localStorage.getItem(teamResultKey) !== null) {
                                localStorage.removeItem(teamResultKey);
                            }
                        }
                    }
                }
            }
        }
        return result;
    }

    _renderFormForBonusQuestion(answer) {
        const key = 'teamMembers';
        const teams = JSON.parse(localStorage.getItem(key));

        let result = '<form id="bonus-form">';
        for (let key in teams) {
            if (teams.hasOwnProperty(key)) {
                let teamName = teams[key].name;
                let members = teams[key].value;
                let teamUuid = teams[key].teamUuid;
                if (members > 0) {
                    result += '<p><input name="teamUuid" type="checkbox" id="uuid-' + teamUuid + '" data-team-name="' + teamName + '" />' +
                        '<label for="uuid-' + teamUuid + '">' + teamName + '</label></p>';
                    result += '<label>' + answer + '</label>';
                } else {
                    //smaz vysledky z local storage
                    //bonusova otazka
                    let bonusKey = 'bonus';
                    const defaultValues = JSON.parse(localStorage.getItem(bonusKey));
                    if (defaultValues) {
                        for (let key in defaultValues) {
                            if (defaultValues.hasOwnProperty(key)) {
                                if (key === teamUuid) {
                                    delete defaultValues[key];
                                }
                            }
                        }
                        this._addTeamPointsToLocalStorage(defaultValues, null, null);
                    }
                }
            }
        }
        result += '<div class="row">' +
            '<button type="submit" class="waves-effect waves-green btn-flat right">Uložiť</button>' +
            '</div>' +
            '</form>';
        return result;
    }

    _triggerBonusForm() {
        this._loadDefaultBonusFormValues();
        const formEl = document.getElementById('bonus-form');
        if (formEl) {
            formEl.addEventListener('submit', event => {
                event.preventDefault();

                const inputs = formEl.querySelectorAll('input[type="checkbox"]');
                let data = {};
                let bonusQuestionTeam = '';
                for (let i = 0; i < inputs.length; i++) {
                    let input = inputs[i];
                    let teamUuid = input.id.replace('uuid-', '');
                    data[teamUuid] = input.checked;

                    if(input.checked){
                        bonusQuestionTeam = teamUuid;
                    }
                }

                localStorage.setItem('bonusQuestionTeam', bonusQuestionTeam);

                this._addTeamPointsToLocalStorage(data, null, null);

                this._renderContinuousOrder();
                $('#bonus-list-collapsible').collapsible('close', 0);
                //$('#bonus-list-collapsible').removeClass('active');
                //event.preventDefault();
                //location.reload();
            });
        }
    }

    _loadDefaultBonusFormValues() {
        let key = 'bonus';

        const defaultValues = JSON.parse(localStorage.getItem(key));
        if (defaultValues) {
            for (let key in defaultValues) {
                if (defaultValues.hasOwnProperty(key)) {
                    document.getElementById('bonus-form').querySelector('#uuid-' + key).checked = defaultValues[key];
                }
            }
        }
    }


    _renderTeamList2() {
        document.getElementById('team-list').innerHTML = this._renderTeamInputs(this._getTeamList(), this._getPromotedTeamUuids(), true);
        this._renderOtherTeamList();
        this._loadDefaultTeamFormValues();
        this._triggerTeamList();
        Materialize.updateTextFields();
    }

    /**
     * @param {Array<Object>} teams entries to render
     * @param {Array<string>} removableUuids teams that get a remove icon (promoted ones)
     * @param {boolean} prefillMembers true for json-source.teams, whose member_count is
     *     reservation.player_count (HOK-392) and is offered as the initial member count;
     *     false for the other-teams block, where member_count is the team size and a
     *     value would promote the team on save. Saved teamMembers override it afterwards.
     * @return {string} html
     */
    _renderTeamInputs(teams, removableUuids = [], prefillMembers = false) {
        let result = '';
        for (let key in teams) {
            if (teams.hasOwnProperty(key)) {
                const teamName = teams[key].name;
                const teamUuid = teams[key].uuid;
                const activeClass = teams[key].onLastQuiz ? ' is-active' : '';
                const memberCount = Number(teams[key].member_count) || 0;
                const valueAttr = prefillMembers && memberCount > 0 ? ` value="` + memberCount + `"` : '';
                const removeLink = removableUuids.indexOf(teamUuid) === -1 ? '' :
                    `<a href="#" class="remove-promoted-team" data-team-uuid="` + teamUuid + `" data-team-name="` + teamName + `" title="Odobrať zo zoznamu"><i class="material-icons">close</i></a>`;

                result += `
                    <div class="input-field` + activeClass + `">
                      <input placeholder="Počet účastníků" data-name="` + teamName + `" id="team-uuid-` + teamUuid + `" type="number" step="1" min="0" max="100" class="validate"` + valueAttr + `>
                      <label for="team-uuid-` + teamUuid + `">` + teamName + removeLink + `</label>
                    </div>
                    `;
            }
        }
        return result;
    }

    /**
     * Eligible teams that did not confirm attendance (HOK-392), collapsed
     * under the confirmed list. The whole block is hidden when there are none
     * (old server response or a json-source cached without allTeams).
     * @return {undefined}
     */
    _renderOtherTeamList() {
        const otherTeams = this._getOtherTeamList();
        const wrapperEl = document.getElementById('other-team-list-wrapper');
        const listEl = document.getElementById('other-team-list');

        if (otherTeams.length === 0) {
            wrapperEl.classList.add('hide');
            listEl.innerHTML = '';
            return;
        }

        wrapperEl.classList.remove('hide');
        wrapperEl.querySelector('.other-team-count').innerText = otherTeams.length;
        listEl.innerHTML = this._renderTeamInputs(otherTeams);
    }

    _triggerTeamList() {
        const formEl = document.getElementById('team-form');

        // _renderTeamList2 vola tuto metodu pri kazdem prekresleni,
        // listener se smi navazat jen jednou
        if (formEl.dataset.submitBound === 'true') {
            return;
        }
        formEl.dataset.submitBound = 'true';

        const toggleEl = formEl.querySelector('#other-team-list-toggle');
        toggleEl.addEventListener('click', event => {
            event.preventDefault();
            const listEl = formEl.querySelector('#other-team-list');
            const collapsed = listEl.classList.toggle('hide');
            toggleEl.querySelector('.material-icons').innerText = collapsed ? 'expand_more' : 'expand_less';
        });

        formEl.addEventListener('click', event => {
            const linkEl = event.target.closest('.remove-promoted-team');
            if (!linkEl) {
                return;
            }
            event.preventDefault();
            const uuid = linkEl.dataset.teamUuid;
            const name = linkEl.dataset.teamName;

            const probe = {};
            probe['team-uuid-' + uuid] = {teamUuid: uuid, value: null, name: name};
            const losingTeams = this._getTeamsLosingResults(probe);
            if (losingTeams.length > 0) {
                this._showConfirmModal('Upozornenie', this._renderLosingResultsHtml(losingTeams), 'Áno, zmazať', 'Späť', () => {
                    this._demoteTeamAndRender(uuid);
                });
                return;
            }
            this._demoteTeamAndRender(uuid);
        });

        formEl.addEventListener('submit', event => {
            event.preventDefault();

            const teamInputs = formEl.querySelectorAll('#team-list input[type="number"], #other-team-list input[type="number"]');
            const teamMembers = this._membersInputsToTeamMembers(teamInputs);

            const losingTeams = this._getTeamsLosingResults(teamMembers);
            if (losingTeams.length > 0) {
                this._showConfirmModal('Upozornenie', this._renderLosingResultsHtml(losingTeams), 'Áno, zmazať', 'Späť', () => {
                    for (let i = 0; i < losingTeams.length; i++) {
                        this._removeTeamResults(losingTeams[i].uuid);
                    }
                    this._saveTeamForm(teamMembers);
                });
                return;
            }

            this._saveTeamForm(teamMembers);
        });
    }

    _renderLosingResultsHtml(losingTeams) {
        let listHtml = 'Tieto tímy majú uložené výsledky, vynulovaním počtu účastníkov budú ich výsledky zmazané:<ul class="browser-default">';
        for (let i = 0; i < losingTeams.length; i++) {
            listHtml += '<li><b>' + losingTeams[i].name + '</b> (kolá ' + losingTeams[i].rounds.join(', ') + ')</li>';
        }
        return listHtml + '</ul>';
    }

    _demoteTeamAndRender(uuid) {
        if (!this._demoteTeam(uuid)) {
            return;
        }
        this._renderTeamList2();
        this._renderRoundList();
        this._renderContinuousOrder();
        this.renderShotsForm();
    }

    _saveTeamForm(teamMembers) {
        this._addTeamMembersToLocalStorage(teamMembers);
        if (this._promoteOtherTeams(teamMembers) > 0) {
            this._renderTeamList2();
        }
        $('#team-list-collapsible').collapsible('close', 0);
        this._renderRoundList();
        this._renderContinuousOrder();
        this.renderShotsForm();
    }

    /**
     * Tymy, ktere by ulozenim formulare prisly o vysledky:
     * novy pocet ucastniku je 0/prazdny, ale existuji ulozene klice round-*.
     */
    _getTeamsLosingResults(newTeamMembers) {
        const result = [];
        const jsonSource = HospodskyKviz._getJsonSourceFromLocalStorage();
        const roundNumbers = jsonSource ? Object.keys(jsonSource.rounds) : [];

        for (let key in newTeamMembers) {
            if (newTeamMembers.hasOwnProperty(key) && !(newTeamMembers[key].value > 0)) {
                const uuid = newTeamMembers[key].teamUuid;
                const rounds = [];
                for (let i = 0; i < roundNumbers.length; i++) {
                    if (localStorage.getItem('round-' + roundNumbers[i] + '--teamUuid-' + uuid) !== null) {
                        rounds.push(roundNumbers[i]);
                    }
                }
                if (rounds.length > 0) {
                    result.push({uuid: uuid, name: newTeamMembers[key].name, rounds: rounds});
                }
            }
        }

        return result;
    }

    _renderModal(round, questionUuid, teamFields, teamName) {
        const modalEl = document.getElementById('modal');
        const titleEl = modalEl.querySelector('#question-title');
        const fieldsEl = modalEl.querySelector('#question-points');
        const roundEl = modalEl.querySelector('input[name="round"]');
        const questionUuidEl = modalEl.querySelector('input[name="teamUuid"]');
        titleEl.innerText = teamName + ' ' + round + '. kolo';
        fieldsEl.innerHTML = teamFields;
        roundEl.value = round;
        questionUuidEl.value = questionUuid;

        //odznaceni radio buttonu
        let allRadios = document.querySelectorAll('.question-radio');
        let booRadio;
        let x = 0;
        for (x = 0; x < allRadios.length; x++) {
            allRadios[x].onclick = function () {
                if (booRadio === this) {
                    this.checked = false;
                    booRadio = null;
                } else {
                    booRadio = this;
                }
            };

        }

        Materialize.updateTextFields();
        $('#modal').modal('open');
        $('#modal .modal-content').scrollTop(0);
    }

    _renderModalQuestion(round, questionFields, teamUuid) {
        const modalEl = document.getElementById('modal');
        const titleEl = modalEl.querySelector('#question-title');
        const fieldsEl = modalEl.querySelector('#team-points');
        const roundEl = modalEl.querySelector('input[name="round"]');
        const questionUuidEl = modalEl.querySelector('input[name="questionUuid"]');
        titleEl.innerText = 'Výsledky pro ' + round + '. kolo';
        fieldsEl.innerHTML = questionFields;
        roundEl.value = round;
        questionUuidEl.value = teamUuid;
        this._triggerQuestionForm();
        Materialize.updateTextFields();
        $('#modal').modal('open');
    }

    _triggerModal() {
        const questionLinks = document.querySelectorAll('.question-modal');
        Array.from(questionLinks).forEach(link => {
            link.addEventListener('click', () => {
                event.preventDefault();
                const round = link.parentNode.parentNode.parentNode.getAttribute('data-round');

                const questionFields = this._renderQuestionList(round);
                const teamUuid = link.getAttribute('data-team-uuid');
                const teamName = link.getAttribute('data-team-name');
                this._renderModal(round, teamUuid, questionFields, teamName);
                this._loadDefaultQuestionFormValues(round, teamUuid);
            });
        });
    }

    _triggerQuestionForm() {
        const formEl = document.getElementById('question-form');
        formEl.addEventListener('submit', event => {
            event.preventDefault();

            const round = formEl.querySelector('input[name="round"]').value;
            const teamUuid = formEl.querySelector('input[name="teamUuid"]').value;
            const pointInputs = formEl.querySelector('#question-points').querySelectorAll('input[type="radio"]');

            const teamPoints = this._pointInputsToTeamPoints(pointInputs);

            this._addTeamPointsToLocalStorage(teamPoints, round, teamUuid);
            $('#modal').modal('close');
            this._renderContinuousOrder();

            let filledSupplementQuestions = JSON.parse(localStorage.getItem('filledSupplementQuestions'));

            if(formEl.querySelector('input[data-is-supplement="true"]:checked') !== null){
                if(filledSupplementQuestions[round].indexOf(teamUuid) === -1){
                    filledSupplementQuestions[round].push(teamUuid);
                }
            } else {
                const indexOfTeamUuid = filledSupplementQuestions[round].indexOf(teamUuid);
                if(indexOfTeamUuid !== -1){
                    filledSupplementQuestions[round].splice(indexOfTeamUuid, 1);
                }
            }

            localStorage.setItem('filledSupplementQuestions', JSON.stringify(filledSupplementQuestions));

            //po ulozeni podbarvy tym
            //$('a[data-team-uuid="' + teamUuid + '"]').setAttribute('style', 'background: ' + dataSaveColor + '');
            $('a[data-team-uuid="' + teamUuid + '"][data-round="' + round + '"]').css('background', dataSaveColor);
        });
    }

    _pointInputsToTeamPoints(pointInputs) {
        let result = {};
        for (let i = 0; i < pointInputs.length; i++) {
            let input = pointInputs[i];
            let questionUuid = input.id.replace('bod-uuid-', '');
            let teamPoints = input.value ? Number(input.value) : null;
            result[input.id] = {questionUuid: questionUuid, value: teamPoints, checked: input.checked};
        }
        return result;
    }

    _membersInputsToTeamMembers(teamInputs) {
        let result = {};
        for (let i = 0; i < teamInputs.length; i++) {
            let input = teamInputs[i];
            let teamUuid = input.id.replace('team-uuid-', '');
            let teamName = input.dataset.name;
            let value = input.value ? Number(input.value) : null;
            result[input.id] = {teamUuid: teamUuid, value: value, name: teamName};
        }
        return result;
    }

    _loadDefaultQuestionFormValues(round, teamUuid) {
        let key = '';
        if (round) {
            key = 'round-' + round + '--teamUuid-' + teamUuid;
        } else {
            key = 'bonus--teamUuid-' + teamUuid;
        }

        const defaultValues = JSON.parse(localStorage.getItem(key));
        if (defaultValues) {
            for (let key in defaultValues) {
                if (defaultValues.hasOwnProperty(key)) {
                    let value = defaultValues[key].checked;
                    let questionFormInput = document.getElementById('question-form').querySelector('#' + key);
                    if (questionFormInput) {
                        document.getElementById('question-form').querySelector('#' + key).checked = value;
                    }
                }
            }
        }
    }

    _loadDefaultTeamFormValues() {
        const key = 'teamMembers';
        const defaultValues = JSON.parse(localStorage.getItem(key));
        if (defaultValues) {
            for (let key in defaultValues) {
                if (defaultValues.hasOwnProperty(key)) {
                    let value = defaultValues[key].value;
                    document.getElementById('team-form').querySelector('#' + key).value = value;
                }
            }
        }
    }

    _loadDefaultNoteFormValues() {
        const key = 'note';
        const defaultValues = JSON.parse(localStorage.getItem(key));
        if (defaultValues) {
            document.getElementById('note-form').querySelector('#' + key).value = defaultValues;
        }
    }

    _addTeamPointsToLocalStorage(data, round, teamUuid) {
        let list = [];
        let key = '';
        if (round && teamUuid) {
            key = 'round-' + round + '--teamUuid-' + teamUuid;
        } else {
            key = 'bonus';
        }
        if (localStorage.getItem(key) !== null) {
            localStorage.removeItem(key);
        }

        localStorage.setItem(key, JSON.stringify(data));
    }

    _addTeamMembersToLocalStorage(data) {
        let list = [];
        const key = 'teamMembers';
        if (localStorage.getItem(key) !== null) {
            localStorage.removeItem(key);
        }

        localStorage.setItem(key, JSON.stringify(data));
    }

    _addNoteToLocalStorage(data) {
        const key = 'note';
        if (localStorage.getItem(key) !== null) {
            localStorage.removeItem(key);
        }

        localStorage.setItem(key, JSON.stringify(data));
    }

    _getTeamMembersFromLocalStorage() {
        let result = {};
        const key = 'teamMembers';
        let data = null;
        if (localStorage.getItem(key) !== null) {
            data = JSON.parse(localStorage.getItem(key));
        }

        if (data) {
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    let value = data[key].value;
                    let item = [];
                    //let teamUuid = key.replace('team-uuid-', '');
                    let teamUuid = data[key].teamUuid;

                    if (value > 0) {
                        if (!result[teamUuid]) {
                            result[teamUuid] = {};
                        }
                        result[teamUuid]['members'] = value;
                    }
                }
            }
        }
        return result;
    }

    _getNoteFromLocalStorage() {
        let result = null;
        const key = 'note';
        if (localStorage.getItem(key) !== null) {
            result = JSON.parse(localStorage.getItem(key));
        }
        return result;
    }

    _getNewTeamsFromLocalStorage() {
        let result = null;
        const key = 'new-teams';
        if (localStorage.getItem(key) !== null) {
            result = JSON.parse(localStorage.getItem(key));
        }
        return result;
    }

    _getTeamPointsFromLocalStorage(teamList) {
        let result = {};
        const questionList = this._getQuestionList();
        for (let i in teamList) {
            if (teamList.hasOwnProperty(i)) {
                let teamUuid = i;
                result[teamUuid] = {};
                for (let j in questionList) {
                    if (questionList.hasOwnProperty(j)) {
                        let number = Number(j);
                        let dataKey = 'round-' + number + '--teamUuid-' + teamUuid;
                        const defaultValues = JSON.parse(localStorage.getItem(dataKey));
                        if (defaultValues) {
                            for (let key in defaultValues) {
                                if (defaultValues.hasOwnProperty(key)) {

                                    let checked = defaultValues[key].checked;
                                    let questionUuid = HospodskyKviz._questionUuidFromInputId(key);
                                    if (checked) {
                                        result[teamUuid][questionUuid] = {};
                                        result[teamUuid][questionUuid]['points'] = defaultValues[key].value;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        const bonusQuestion = this._getBonusQuestion();
        let key = 'bonus';
        const defaultValues = JSON.parse(localStorage.getItem(key));
        if (defaultValues) {
            for (let key in defaultValues) {
                if (defaultValues.hasOwnProperty(key)) {
                    if (defaultValues[key]) {
                        result[key][bonusQuestion['uuid']] = {};
                        result[key][bonusQuestion['uuid']]['points'] = 1;
                    }
                }
            }
        }

        return result;
    }

    _addJsonSourceToLocalStorage(jsonSource) {
        if (localStorage.getItem('json-source') !== null) {
            localStorage.removeItem('json-source');
        }

        localStorage.setItem('json-source', JSON.stringify(jsonSource));
    }

    static _getJsonSourceFromLocalStorage() {
        if (localStorage.getItem('json-source') === null) {
            return null;
        }
        return JSON.parse(localStorage.getItem('json-source'));
    }

    getShotsFromLocalStorage() {
        if (localStorage.getItem('shots') === null) {
            return null;
        }
        return JSON.parse(localStorage.getItem('shots'));
    }

    _clearDataFromLocalStorage() {
        localStorage.clear();
    }

    _triggerSynchronizeResults() {
        const element = document.getElementById('synchronize-results');
        element.addEventListener('click', event => {
            event.preventDefault();
            const pinModalEl = $('#modal-pin-verify-send');
            pinModalEl.modal('open');

        });
    }

    _triggerCreateTeam() {
        const pubs = this._getPubList();
        const title = this._getTitle();

        let result = '';
        for (let key in pubs) {
            if (pubs.hasOwnProperty(key)) {
                let pubName = pubs[key].name;
                let pubUuid = pubs[key].uuid;
                var selected = '';
                if (title.indexOf(pubName) !== -1) {
                    selected = 'selected';
                    localStorage.setItem('quizPubUuid', pubUuid);
                }

                result += `
                <option value="` + pubUuid + `" ` + selected + `>` + pubName + `</option>
                `;
            }
        }

        const selectPub = document.getElementById('select-pub');
        selectPub.innerHTML = result;

        $('.select2').select2();

        const element = document.getElementById('add-team-button');
        element.addEventListener('click', event => {
            event.preventDefault();
            const teamCreateModalEl = $('#modal-create-team');
            teamCreateModalEl.modal('open');


        });
    }


    _triggerNote() {
        const formEl = document.getElementById('note-form');
        formEl.addEventListener('submit', event => {
            event.preventDefault();

            const note = formEl.querySelector('textarea').value;
            this._addNoteToLocalStorage(note);
            $('#note-collapsible').collapsible('close', 0);

            //location.reload();
        });
    }

    _genereateUuid() {
        var uuid = "", i, random;
        for (i = 0; i < 32; i++) {
            random = Math.random() * 16 | 0;
            uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
        }
        return uuid;

        /*
        return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        )
        */
    }


    _renderContinuousOrder() {
        const table = document.getElementById('result-table');
        table.innerHTML =
            '<thead>' +
            '<tr>' +
            '<th>Poradie</th>' +
            '<th>Tím</th>' +
            '<th>Body</th>' +
            (this.useShots ? '<th>Za panáky</th>' : '') +
            '<th>Z dopln.</th>' +
            '<th>Členov</th>' +
            '<th>V kole</th>' +
            '</tr>' +
            '</thead>';

        let maxPubMembers = this._getMaxPubMembers();
        if (maxPubMembers === null) {
            maxPubMembers = 8;
        }
        let results = this._getContinuousOrder(maxPubMembers);
        let longTermMaxPoint = this._getLongTermMaxPoint();

        let order = 1;
        let index = 1;
        let dataToSave = {};

        for (let i in results) {
            if (results.hasOwnProperty(i)) {
                dataToSave[results[i].teamUuid] = {};
                dataToSave[results[i].teamUuid]['pointsBeforeMinus'] = 0;
                dataToSave[results[i].teamUuid]['pointsAfterMinus'] = 0;
                dataToSave[results[i].teamUuid]['longTermPoints'] = 0;

                if (results[i - 1]) {
                    if (results[i].split && (results[i].points === results[i - 1].points) && (results[i].max_round_points === results[i - 1].max_round_points) && (results[i].members === results[i - 1].members) && (results[i].points_suppl === results[i - 1].points_suppl)) {
                        index++;
                    }
                    else {
                        order += index;
                        longTermMaxPoint -= index;
                        index = 1;
                    }
                }
                let pointsBeforeMinus = results[i].points;

                let afterMinus = 0;
                if (maxPubMembers > 0) {
                    afterMinus = results[i].members - maxPubMembers > 0 ? results[i].members - maxPubMembers : 0;
                }
                let pointsAfterMinus = results[i].points - afterMinus;

                //let minusLongTerm = results[i].members - maxPubMembers > 0 ? results[i].members - maxPubMembers : 0;
                let longTermPoints = (longTermMaxPoint);
                if (results[i].bonus) {
                    longTermPoints++;
                }

                table.innerHTML +=
                    '<tr>' +
                    '<td>' + order + '. </td>' +
                    '<td>' + results[i].name + ' </td>' +
                    '<td>' + pointsAfterMinus + ' </td>' +
                    (this.useShots ? '<td>' + results[i].points_shots + ' </td>' : '') +
                    '<td>' + results[i].points_suppl + ' </td>' +
                    '<td>' + results[i].members + ' </td>' +
                    '<td>' + results[i].max_round_points + ' </td>' +
                    '</tr>';

                dataToSave[results[i].teamUuid]['pointsBeforeMinus'] = pointsBeforeMinus;
                dataToSave[results[i].teamUuid]['pointsAfterMinus'] = pointsAfterMinus;
                dataToSave[results[i].teamUuid]['longTermPoints'] = longTermPoints;
                dataToSave[results[i].teamUuid]['pointsWithoutSupplement'] = results[i].points_without_suppl;
                dataToSave[results[i].teamUuid]['pointsWithoutShots'] = results[i].points_without_shots;
                dataToSave[results[i].teamUuid]['pointsSupplement'] = results[i].points_suppl;
                dataToSave[results[i].teamUuid]['pointsShots'] = results[i].points_shots;
                dataToSave[results[i].teamUuid]['maxPointsPerRound'] = results[i].max_round_points;
                dataToSave[results[i].teamUuid]['order'] = order;
            }
        }
        var html = table.innerHTML;
        html = html.replace(/<\/tbody><tbody>/g, '');
        table.innerHTML = html;
        this._savePointsResult(dataToSave);
    }


    _getContinuousOrder(maxPubMembers) {
        let result = [];

        const questionList = this._getQuestionList();
        const key = 'teamMembers';
        const teams = JSON.parse(localStorage.getItem(key));

        const pointsShots = this.getShotsFromLocalStorage();

        let areAllResults = true;
        for (let i in teams) {
            if (teams.hasOwnProperty(i)) {
                let teamName = teams[i].name;
                let members = teams[i].value;
                let teamUuid = teams[i].teamUuid;
                if (members > 0) {
                    result[teamUuid] = [];
                    result[teamUuid]['points'] = 0;
                    result[teamUuid]['points_after_delete'] =
                    result[teamUuid]['points_without_suppl'] =
                    result[teamUuid]['points_without_shots'] = members - maxPubMembers > 0 ? maxPubMembers - members : 0;
                    result[teamUuid]['points_suppl'] = 0;
                    result[teamUuid]['max_round_points'] = 0;
                    result[teamUuid]['members'] = members;
                    result[teamUuid]['name'] = teamName;
                    result[teamUuid]['bonus'] = false;
                    result[teamUuid]['split'] = false;
                    result[teamUuid]['teamUuid'] = teamUuid;

                    result[teamUuid]['points_shots'] = pointsShots && pointsShots['pointsShots'] && pointsShots['pointsShots'][teamUuid] ? pointsShots['pointsShots'][teamUuid] : 0;
                    result[teamUuid]['points'] += result[teamUuid]['points_shots'];
                    result[teamUuid]['points_after_delete'] += result[teamUuid]['points_shots'];


                  let roundMax = 0;
                    for (let j in questionList) {
                        if (questionList.hasOwnProperty(j)) {
                            let number = Number(j);
                            let dataKey = 'round-' + number + '--teamUuid-' + teamUuid;

                            let roundSum = 0;
                            const defaultValues = JSON.parse(localStorage.getItem(dataKey));
                            if (defaultValues) {
                                for (let key in defaultValues) {
                                    if (defaultValues.hasOwnProperty(key)) {

                                        let checked = defaultValues[key].checked;
                                        let points = parseFloat(defaultValues[key].value);
                                        let questionUuid = HospodskyKviz._questionUuidFromInputId(key);

                                        if (checked) {
                                            result[teamUuid]['points'] += points;
                                            result[teamUuid]['points_after_delete'] += points;
                                            result[teamUuid]['points_without_shots'] += points;
                                            roundSum += points;
                                            if (!this._isQuestionSupplement(questionUuid, questionList[j].questions)) {
                                                result[teamUuid]['points_without_suppl'] += points;
                                            } else {
                                                result[teamUuid]['points_suppl'] += points;
                                            }
                                        }
                                    }
                                }
                            } else {
                                areAllResults = false;
                            }
                            if (roundSum > roundMax) {
                                roundMax = roundSum;
                            }
                        }
                    }
                    result[teamUuid]['max_round_points'] = roundMax;
                }
            }
        }
        //bonusova otazka
        const bonusQuestion = this._getBonusQuestion();
        if (bonusQuestion) {
            let bonusKey = 'bonus';
            const defaultValues = JSON.parse(localStorage.getItem(bonusKey));
            if (defaultValues) {
                for (let key in defaultValues) {
                    if (defaultValues.hasOwnProperty(key)) {
                        result[key]['bonus'] = defaultValues[key];
                    }
                }
            } else {
                areAllResults = false;
            }
        }

        // zmen nadpis na koncove poradi
        if (areAllResults) {
            let orderTitle = document.getElementById('order-title');
            orderTitle.innerHTML = '<b>Konečné poradie</b>';
        }
        // <li><span>1)</span> Počet bodů</li>
        //     <li><span>2)</span> Počet bodů bez doplňovacích otázek</li>
        //     <li><span>3)</span> Počet členů týmu (méně členů = vyšší umístění)</li>
        //     <li><span>4)</span> Nejvyšší počet bodů získaný v jednotlivém kole</li>
        //     <li><span>5)</span> 56. otázka</li>
        //     <li><span>6)</span> Hromadná bitka týmů před hospodou</li>

        let sortArray = [];
        for (let l in result) sortArray.push(result[l]);

        sortArray.sort(function (a, b) {
            let c = a['points_after_delete'];
            let d = b['points_after_delete'];
            if (c === d) {
                // Počet bodů bez panaku
                c = a['points_without_shots'];
                d = b['points_without_shots'];
            }
            if (c === d) {
                // Počet bodů bez doplňovacích otázek
                c = a['points_without_suppl'];
                d = b['points_without_suppl'];
            }
            if (c === d) {
                // Počet členů týmu (méně členů = vyšší umístění)
                c = b['members'];
                d = a['members'];
            }
            if (c === d) {
                //Nejvyšší počet bodů získaný v jednotlivém kole
                c = a['max_round_points'];
                d = b['max_round_points'];
            }
            if (c === d) {
                //56. otázka
                c = a['bonus'];
                d = b['bonus'];
            }
            if (c === d) {
                a['split'] = true;
                b['split'] = true;
            }
            return c < d ? 1 : (c > d ? -1 : 0);
        });

        return sortArray;
    }


    _isQuestionSupplement(questionUuid, questionList) {
        questionUuid = questionUuid.replace('pul-', '');

        for (let j in questionList) {
            let uuid = questionList[j]['uuid'];
            if (questionUuid === uuid && questionList[j]['is_supplement']) {
                return true;
            }
        }
        return false;
    }

    _toObject(arr) {
        var rv = {};
        for (var i = 0; i < arr.length; ++i)
            if (arr[i] !== undefined) rv[i] = arr[i];
        return rv;
    }

    _getLongTermMaxPoint() {
        let longTermMaxPoint = 0;
        const key = 'teamMembers';
        const teams = JSON.parse(localStorage.getItem(key));
        for (let i in teams) {
            if (teams.hasOwnProperty(i)) {
                let members = teams[i].value;
                if (members > 0) {
                    longTermMaxPoint++;
                }
            }
        }
        return longTermMaxPoint;
    }

    _getMaxPubMembers() {
        let result = null;
        const jsonData = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (jsonData) {
            result = jsonData.pub_max_members;
        }
        return result;
    }

    _getTitle() {
        let result = null;
        const jsonData = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (jsonData) {
            result = jsonData.title;
        }
        return result;
    }

    _getGeneratedQuizUuid() {
        let result = null;
        const jsonData = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (jsonData) {
            result = jsonData.generated_quiz_uuid;
        }
        return result;
    }

    _savePointsResult(data) {
        let key = 'points-result';
        if (localStorage.getItem(key) !== null) {
            localStorage.removeItem(key);
        }

        localStorage.setItem(key, JSON.stringify(data));
    }


    _getPointsResult() {
        let key = 'points-result';
        if (localStorage.getItem(key) === null) {
            return null;
        }
        return JSON.parse(localStorage.getItem(key));
    }

    _hasTeamSaveResult(teamUuid, round) {
        let key = 'round-' + round + '--teamUuid-' + teamUuid;
        return localStorage.getItem(key) !== null;
    }

    _triggerDeleteQuiz() {
        const element = document.getElementById('delete-quiz');
        element.addEventListener('click', event => {
            event.preventDefault();
            this._clearDataFromLocalStorage();
            location.reload();
        });
        const elementMenu = document.getElementById('delete-quiz-menu');
        elementMenu.addEventListener('click', event => {
            event.preventDefault();
            this._clearDataFromLocalStorage();
            location.reload();
        });
    }

    //trigger pro odeslani formulare vytvoreni tymu
    _triggerCreateTeamSubmit() {
        const formEl = document.getElementById('create-team-form');
        formEl.addEventListener('submit', event => {
            event.preventDefault();
            const quizPubUuid = localStorage.getItem('quizPubUuid');

            let teamName = formEl.querySelector('input[name="teamName"]').value.capitalize();
            let pubName = document.querySelector('#select-pub option:checked').text;
            let pubUuid = document.querySelector('#select-pub option:checked').value;
            let teamUuid = this._genereateUuid();

            if (teamName === '') {
                return;
            }
            let teamExist = false;
            let newTeamList = [];
            if (localStorage.getItem('new-teams') !== null) {
                newTeamList = JSON.parse(localStorage.getItem('new-teams'));
            }
            newTeamList.map(function(item) {
                if(item.name === teamName && item.pub_uuid === pubUuid) {
                    teamExist = true;
                }
            });
            if (teamExist) {
                //alert('Tým již existuje');
                this._showModalMessage('Chyba', 'Tým již existuje');
                return;
            }

            //uloz tym do hlavniho pole
            let teamList = this._getTeamList();
            let newTeam = '{"uuid":"' + teamUuid + '","name":"' + teamName + '","member_count":0}';

            teamList.push(JSON.parse(newTeam));
            teamList.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });

            this._saveTeamList(teamList);

            //jeste uloz tym do samostatneho pole
            let newTeam2 = '{"uuid":"' + teamUuid + '","name":"' + teamName + '","member_count":0, "pub_uuid": "' + pubUuid + '"}';
            this._saveNewTeam(JSON.parse(newTeam2));

            formEl.querySelector('input[name="teamName"]').value = '';


            const teamCreateModalEl = $('#modal-create-team');
            teamCreateModalEl.modal('close');
            this._renderTeamList2();

            $('#select-pub').val(quizPubUuid);
            $('#select-pub').trigger('change');
        });
    }

    _getTeamNameByUuid(uuid) {
        const teamMembers = JSON.parse(localStorage.getItem('teamMembers')) || {};
        if (teamMembers['team-uuid-' + uuid]) {
            return teamMembers['team-uuid-' + uuid].name;
        }

        const jsonSource = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (jsonSource) {
            for (let i in jsonSource.teams) {
                if (jsonSource.teams.hasOwnProperty(i) && jsonSource.teams[i].uuid === uuid) {
                    return jsonSource.teams[i].name;
                }
            }
        }

        const newTeams = this._getNewTeamsFromLocalStorage();
        if (newTeams) {
            for (let i = 0; i < newTeams.length; i++) {
                if (newTeams[i].uuid === uuid) {
                    return newTeams[i].name;
                }
            }
        }

        return uuid;
    }

    /**
     * Kontrola konzistence dat pred odeslanim (spec:
     * docs/superpowers/specs/2026-07-06-send-validation-design.md).
     * Vraci pole retezcu s popisem problemu; prazdne pole = vse v poradku.
     * Nic nemutuje - jen cte localStorage.
     */
    _validateSendConsistency() {
        const problems = [];
        const jsonSource = HospodskyKviz._getJsonSourceFromLocalStorage();
        if (!jsonSource) {
            return problems;
        }

        const roundNumbers = Object.keys(jsonSource.rounds);
        const teamMembers = JSON.parse(localStorage.getItem('teamMembers')) || {};

        // aktivni tymy (uuid -> nazev): jen ty s poctem ucastniku > 0
        const activeTeams = {};
        for (let key in teamMembers) {
            if (teamMembers.hasOwnProperty(key) && teamMembers[key].value > 0) {
                activeTeams[teamMembers[key].teamUuid] = teamMembers[key].name;
            }
        }

        // 1) kazdy aktivni tym ma ulozeny vysledek kazdeho kola
        //    (kriterium = existence klice, vytvari se i pri ulozeni bez zaskrtnuti)
        for (let uuid in activeTeams) {
            if (activeTeams.hasOwnProperty(uuid)) {
                const missingRounds = [];
                for (let i = 0; i < roundNumbers.length; i++) {
                    if (localStorage.getItem('round-' + roundNumbers[i] + '--teamUuid-' + uuid) === null) {
                        missingRounds.push(roundNumbers[i]);
                    }
                }
                if (missingRounds.length > 0) {
                    problems.push('<b>' + activeTeams[uuid] + '</b>: nie sú uložené výsledky pre kolá ' + missingRounds.join(', '));
                }
            }
        }

        // 2) nove tymy bez vyplnenych ucastniku
        const newTeams = this._getNewTeamsFromLocalStorage();
        if (newTeams) {
            for (let i = 0; i < newTeams.length; i++) {
                if (!activeTeams[newTeams[i].uuid]) {
                    problems.push('<b>' + newTeams[i].name + '</b>: nemá vyplnený počet účastníkov a nebude odoslaný');
                }
            }
        }

        // 3) osirele vysledky: klice round-* patrici tymu bez ucastniku
        //    (dedup pres uuid - jeden tym muze mit klicu vic)
        const orphanUuids = {};
        for (let i = 0; i < localStorage.length; i++) {
            const match = localStorage.key(i).match(/^round-\d+--teamUuid-(.+)$/);
            if (match && !activeTeams[match[1]]) {
                orphanUuids[match[1]] = true;
            }
        }
        for (let uuid in orphanUuids) {
            if (orphanUuids.hasOwnProperty(uuid)) {
                problems.push('<b>' + this._getTeamNameByUuid(uuid) + '</b>: má uložené výsledky, ale nemá vyplnený počet účastníkov a nebude odoslaný');
            }
        }

        return problems;
    }

    _sendResults(payload, $modalEl, pinModalEl) {
        setTimeout(function () {
            $.ajax({
                method: 'POST',
                url: 'https://www.hospodskykviz.sk/api/insertappresult',
                data: payload,
                dataType: 'json'
            }).done(function (response) {
                if (response.state === false) {
                    // validace nesprávného pinu
                    this._showModalMessage('Chyba při odesílání', response.message);
                } else {
                    this._clearDataFromLocalStorage();
                    pinModalEl.modal('close');
                    this._renderRoundList();
                    this._renderTeamList2();
                    this._loadDefaultNoteFormValues();
                    this._renderFormForBonusQuestion();
                    this._renderContinuousOrder();
                    this._addInitHide();
                    this._showModalMessage('Upozornenie', 'Výsledky boli úspešne odoslané');
                }

                $modalEl.removeClass('loading');
            }.bind(this));
        }.bind(this), 1500);
    }

    _triggerSendResultForm() {
        const formEl = document.getElementById('pin-form-send');
        formEl.addEventListener('submit', event => {
            event.preventDefault();
            const pinModalEl = $('#modal-pin-verify-send');

            var $modalEl = $(formEl).closest('div.form-container');
            $modalEl.addClass('loading');

            const pin = formEl.querySelector('input[name="pin"]').value;
            let teamList = this._getTeamMembersFromLocalStorage();
            let results = this._getTeamPointsFromLocalStorage(teamList);
            let note = this._getNoteFromLocalStorage();
            let newTeams = this._getNewTeamsFromLocalStorage();
            let pointsResult = this._getPointsResult();
            let generatedQuizUuid = this._getGeneratedQuizUuid();
            let shots = this.getShotsFromLocalStorage();

            if(jQuery.isEmptyObject(results)) {
                $modalEl.removeClass('loading');
                pinModalEl.modal('close');
                this._showModalMessage('Upozornenie', 'Nemáte zadané žiadne výsledky');
                return;
            }

            const filledSupplementQuestions = JSON.parse(localStorage.getItem('filledSupplementQuestions'));
            let isSomeSupplementMissing = false;

            for(let key in filledSupplementQuestions){
                if(!filledSupplementQuestions.hasOwnProperty(key)){
                    continue;
                }

                if(filledSupplementQuestions[key].length === 0){
                    isSomeSupplementMissing = true;
                    break;
                }
            }

            const isBonusQuestionMissing = !localStorage.getItem('bonusQuestionTeam');

            if(isSomeSupplementMissing || isBonusQuestionMissing){
                $modalEl.removeClass('loading');
                pinModalEl.modal('close');
                this._showModalMessage('Upozornenie', 'Zadajte výsledok všetkých doplnkových otázok a bonusovú otázku');

                return;
            }

            const problems = this._validateSendConsistency();

            const payload = {
                pin: pin,
                teams: teamList,
                results: results,
                note: note,
                newTeams: newTeams,
                pointsResult: pointsResult,
                generatedQuizUuid: generatedQuizUuid,
                shots: shots
            };

            if (problems.length > 0) {
                $modalEl.removeClass('loading');
                pinModalEl.modal('close');

                let listHtml = 'Skontrolujte výsledky pred odoslaním:<ul class="browser-default">';
                for (let i = 0; i < problems.length; i++) {
                    listHtml += '<li>' + problems[i] + '</li>';
                }
                listHtml += '</ul>';

                this._showConfirmModal('Upozornenie', listHtml, 'Odoslať aj tak', 'Opraviť', () => {
                    this._sendResults(payload, $modalEl, pinModalEl);
                });
                return;
            }

            this._sendResults(payload, $modalEl, pinModalEl);
        });
    }

    /**
     * Displays overlay with "Please wait" text. Based on bootstrap modal. Contains animated progress bar.
     */
    _showModalMessage(title, message) {
        var modalLoading = '<div class="modal" id="pleaseWaitDialog" data-backdrop="static" data-keyboard="false role="dialog"> ' +
            '<div class="modal-dialog"> ' +
            '<div class="modal-content"> ' +
            '<div class="modal-header"> ' +
            '<h5 class="modal-title">'+title+'</h5> ' +
            '</div> ' +
            '<div class="modal-body"> ' + message +
            '</div> ' +
            '</div> ' +
            '</div> ' +
            '<div class="modal-footer">' +
            '<button id="modal-message-close" class="modal-action waves-effect waves-green btn-flat ">Zatvoriť</button>' +
            '</div>' +
            '</div>';
        $(document.body).append(modalLoading);
        $("#pleaseWaitDialog").modal("open");
        $('#modal-message-close').on('click', function () {
            $('#pleaseWaitDialog').modal('close');
            $('#pleaseWaitDialog').remove();
        });
    }

    /**
     * Confirm dialog by the pattern of _showModalMessage: two buttons,
     * onConfirm is called only when confirmed. Removed from DOM on close.
     */
    _showConfirmModal(title, messageHtml, confirmLabel, cancelLabel, onConfirm) {
        $('#confirmDialog').modal('close');
        $('#confirmDialog').remove();
        var modalHtml = '<div class="modal" id="confirmDialog">' +
            '<div class="modal-content">' +
            '<h5 class="modal-title">' + title + '</h5>' +
            '<div class="modal-body">' + messageHtml + '</div>' +
            '</div>' +
            '<div class="modal-footer">' +
            '<button id="confirm-dialog-cancel" class="modal-action waves-effect waves-red btn-flat">' + cancelLabel + '</button>' +
            '<button id="confirm-dialog-confirm" class="modal-action waves-effect waves-green btn-flat">' + confirmLabel + '</button>' +
            '</div>' +
            '</div>';
        $(document.body).append(modalHtml);
        $('#confirmDialog').modal('open');
        $('#confirm-dialog-confirm').on('click', function () {
            $('#confirmDialog').modal('close');
            $('#confirmDialog').remove();
            onConfirm();
        });
        $('#confirm-dialog-cancel').on('click', function () {
            $('#confirmDialog').modal('close');
            $('#confirmDialog').remove();
        });
    }

    renderShotsForm() {
        if(!this.useShots) {
          $('#shots-collapsible').addClass('hide')
          return
        }

        const key = 'teamMembers';
        const teams = JSON.parse(localStorage.getItem(key)) || {};

        const defaultValues = this.getShotsFromLocalStorage();

        const shotFormTbody = $('#shot-form-tbody');

        shotFormTbody.html('<tr>\n' +
            '<th>Tím</th>\n' +
            '<th>Bod za panákov</th>\n' +
            '</tr>');

        Object.keys(teams).forEach(function (key) {
            if(teams[key].value !== null && teams[key].value > 0) {

                const teamUuid = teams[key].teamUuid;
                const teamName = teams[key].name;

                const checked = defaultValues && defaultValues['pointsShots'] && defaultValues['pointsShots'][teamUuid] != null ? defaultValues['pointsShots'][teamUuid] : false;

                const tableRow = '<tr><td>' + teamName + '</td><td><input value="1" ' + (checked ? ' checked ' : '') + ' type="checkbox" name="pointsShots-' + teamUuid + '" id="pointsShots-' + teamUuid + '"><label class="" for="pointsShots-' + teamUuid + '"></label></td></tr>';

                shotFormTbody.append(tableRow);
            }
        });
    }

    triggerShotsForm() {
        if(!this.useShots) {
          return
        }
        const formEl = document.getElementById('shot-form');
        formEl.addEventListener('submit', event => {
            event.preventDefault();

            const inputs = formEl.querySelectorAll('input');

            let data = {};
            data['pointsShots'] = {};

            inputs.forEach(function(element){
                const value = $(element).val();
                const nameArray = $(element).attr('name').split('-');

                data[nameArray[0]][nameArray[1]] = element.checked ? Number(value) : 0;

            });

            localStorage.setItem('shots', JSON.stringify(data));

            $('#shots-collapsible').collapsible('close', 0);

            this._renderContinuousOrder();
        });
    }
}

$(document).ready(function () {
    const hq = new HospodskyKviz();
    hq.init();
    hq.render();


    // 2 Capitalize string first character to uppercase
    jQuery('.team-name').keyup(function() {
        var caps = jQuery('.team-name').val();
        caps = caps.charAt(0).toUpperCase() + caps.slice(1);
        jQuery('.team-name').val(caps);
    });
});
